export function cleanClientUrl(pageId) {
    const protocol = window.location.protocol; // "http:" или "https:"
    const host = window.location.host;         // "://domain.com", "localhost:3000", "://domain.com"

    // Регулярное выражение ищет поддомен третьего уровня (например, "c1.")
    // Оно сработает только если в хосте есть как минимум две точки перед двоеточием/концом строки
    const cleanHost = host.replace(/^[^.]+\.(?=[^.]+\.[^.:]+)/, '');

    return `${protocol}//${cleanHost}/client-info/${pageId}`;
}

export function cleanProjectUrl(pageId) {
    const protocol = window.location.protocol; // "http:" или "https:"
    const host = window.location.host;         // "://domain.com", "localhost:3000", "://domain.com"

    // Регулярное выражение ищет поддомен третьего уровня (например, "c1.")
    // Оно сработает только если в хосте есть как минимум две точки перед двоеточием/концом строки
    const cleanHost = host.replace(/^[^.]+\.(?=[^.]+\.[^.:]+)/, '');

    return `${protocol}//${cleanHost}/client-project/${pageId}`;
}
